import React from 'react'
import Layout from 'features/layout/components/Layout'
import EpgTimingForm from '../components/EpgTimingForm'

const EpgTimingFormPage = (props) => {
  return (
    <Layout>
      <EpgTimingForm />
    </Layout>
  )
}

export default EpgTimingFormPage
